import { loadJs } from './Util'

export default {
  getComponent({ type, version }) {
    let C_KEY = `${type}@${version.replace('.beta', '')}`
    return this.componentCache[C_KEY]
  },
  componentCache: {},
  requestCache: {},
  async load({ type, path, version }) {
    version = version || '0.1.0'
    let C_KEY = `${type}@${version.replace('.beta', '')}`
    let component = this.getComponent({ type, version })
    if (component) return component
    let request, url
    if (!this.requestCache[C_KEY]) {
      url = path
      // if (process.env.CODE_ENV !== 'production') {
      //   url += '?' + new Date().getTime()
      // }
      // 静态资源挂了，导致恢复后，部分手机上脚本加载失败
      if (process.env.CODE_ENV === 'production') {
        if (url.indexOf('?') >= 0) {
          url += '&v=1'
        } else {
          url += '?v=1'
        }
      }
      this.requestCache[C_KEY] = request = loadJs(location.protocol === 'https:' ? url.replace(/^http:/, 'https:') : url)
    } else {
      request = this.requestCache[C_KEY]
    }
    try {
      await request;
      component = window[C_KEY + 'index'] || window[C_KEY] || window[C_KEY.replace('@', '')]
      if (component) {
        this.componentCache[C_KEY] = component = component.default || component
        return component
      } else {
        console.error(`加载 [${type}][${version}] ${path} 脚本失败`)
      }
    } catch (h) {
      console.error(`加载 [${type}][${version}] ${path} 脚本发生异常`, h)
    }
  }
}
